<script setup>
import {ref, onBeforeMount} from "vue";
import router from "@/router/index.js";
import createBrandMember from "./components/createBrandMember/index.vue"
import {getRoute} from "@/hooks/getRoute.js";
import {addServiceProviderIgnoreTenant} from "@/api/serviceProvider/ignoreTenant.js";
const {route} = getRoute()

onBeforeMount(() => {
  if (!route.query.tenantId) {
    loading.value = true
    ElMessage.error("暂无商家信息")
  } else if (!route.query.storeId) {
    loading.value = true
    ElMessage.error("暂无品牌方员工信息")
  } else {
    ruleForm.value.tenantId = route.query.tenantId
    ruleForm.value.storeId = route.query.storeId
  }
})
// 加载状态
const loading = ref(false)
/*表单信息相关*/
// 表单
const ruleForm = ref({
  tenantId: null,
  storeId: null,
  avatar: null,
  name: null,
  nameEn: null,
  phone: null,
  providerJobTitle: null,
  providerJobTitleEn: "Coming Soon ...",
  providerType: "BRAND_EMPLOYEE",
})
// 处理创建摄影师
const handleCreateBrandMember = async () => {
  try {
    loading.value = true
    await addServiceProviderIgnoreTenant(ruleForm.value)
    ElMessage.success("新建成功")
    router.back()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <createBrandMember v-loading="loading" v-model="ruleForm" @success="handleCreateBrandMember"></createBrandMember>
</template>

<style lang="scss" scoped>

</style>
